import React from 'react'
import "./qualifications.css";

// Newest first. Entries alternate left/right on the timeline.
const timeline = [
  {
    icon: "uil uil-briefcase-alt",
    title: "Software Engineer - Backend Platform Lead",
    subtitle: "UnionBank of the Philippines",
    period: "2025 - Present",
  },
  {
    icon: "uil uil-briefcase-alt",
    title: "Software Engineer",
    subtitle: "HC Consumer Finance Philippines (Home Credit)",
    period: "2024 - 2025",
  },
  {
    icon: "uil uil-briefcase-alt",
    title: "Software Engineer · Java Spring",
    subtitle: "White Cloak Technologies Inc.",
    period: "2021 - 2024",
  },
  {
    icon: "uil uil-graduation-cap",
    title: "BS in Electrical Engineering",
    subtitle: "Far Eastern University - Institute of Technology",
    period: "Graduated 2021",
  },
];

const Qualifications = () => {
  return (
    <section className="qualification section" id="qualifications">
      <h2 className="section_title">Qualifications</h2>
      <span className="section_subtitle">My personal journey</span>

      <div className="qualification_container container">
          <div className="qualification_content">
            {timeline.map((entry, index) => (
              <div
                key={entry.title}
                className={index % 2 === 0 ? "qualification_data_left left" : "qualification_data right"}
              >
                <div className="qualification_information">
                  <h3 className="qualification_title">
                    <i className={`${entry.icon} qualification_icon`}></i> {entry.title}
                  </h3>
                  <span className="qualification_subtitle">{entry.subtitle}</span>
                  <div className="qualification_calender">
                    <i className="uil uil-calendar-alt calendar_icon"></i>
                    {entry.period}
                  </div>
                </div>
              </div>
            ))}
          </div>
      </div>
    </section>
  )
}

export default Qualifications
